__turbopack_context__.v({
  "button": "ejgoPG_button",
  "container": "ejgoPG_container",
  "isHeading": "ejgoPG_isHeading",
  "item": "ejgoPG_item",
  "width--maxcontent": "ejgoPG_width--maxcontent",
});
